import shortid from 'shortid';
import actions from './actions';
import AnchorApi from '../../../modules/AnchorAPI';
import { duckOperations as podcastOperations } from '../../../store/global/podcast';

const addAudioSplitterSplit = actions.addAudioSplitterSplit;
const removeAudioSplitterSplit = actions.removeAudioSplitterSplit;
const setAudioSplitterSplits = actions.setAudioSplitterSplits;
const setAudioSplitterActiveSplitId = actions.setAudioSplitterActiveSplitId;
const setAudioSplitterDurationMS = actions.setAudioSplitterDurationMS;
const setLastSplitterPlacementPosition =
  actions.setLastSplitterPlacementPosition;
const setIsProcessing = actions.setIsProcessing;

const showCloseConfirmation = () => dispatch => {
  dispatch(actions.setIsShowingCloseConfirmation(true));
};

const hideCloseConfirmation = () => dispatch => {
  dispatch(actions.setIsShowingCloseConfirmation(false));
};

const openAndSetupForAudio = audio => dispatch => {
  dispatch(actions.setAudio(audio));
  dispatch(actions.setAudioSplitterDurationMS(audio.duration));
  dispatch(podcastOperations.fetchPodcastAndSet()).then(() => {
    // TODO: We should probably have a visual indication that
    //       the modal isn't ready yet (because it hasn't synced
    //       podcast from the server)
  });
  dispatch(actions.setIsShowing(true));
};

const closeAndReset = () => dispatch => {
  dispatch(actions.setIsShowing(false));
  dispatch(actions.resetStore());
};

const showActiveSplitButtonForSplitId = splitId => dispatch => {
  dispatch(actions.setAudioSplitterActiveSplitId(splitId));
};
const hideActiveSplitButton = () => dispatch => {
  dispatch(actions.setAudioSplitterActiveSplitId(null));
};

const showSplitterSplitButton = () => dispatch => {
  dispatch(actions.setAudioSplitterIsShowingSplitButton(true));
};

const hideSplitterSplitButton = () => dispatch => {
  dispatch(actions.setAudioSplitterIsShowingSplitButton(false));
};

const showSplitterSplitButtonAndHideActiveSplitButton = () => dispatch => {
  dispatch(showSplitterSplitButton());
  dispatch(hideActiveSplitButton());
};

const showActiveSplitButtonForIdAndHideSplitterSplitButton = splitId => dispatch => {
  dispatch(showActiveSplitButtonForSplitId(splitId));
  dispatch(hideSplitterSplitButton());
};

const play = () => dispatch => {
  dispatch(actions.setAudioSplitterIsShowingSplitButton(false));
  dispatch(actions.setIsPlaying(true));
};

const pause = () => dispatch => {
  dispatch(actions.setIsPlaying(false));
};

const pauseAndShowSplitButtonAndHideActiveSplitButton = () => dispatch => {
  dispatch(showSplitterSplitButtonAndHideActiveSplitButton());
  dispatch(pause());
};

const addSplitAtPositionAndHideAllButtons = position => dispatch => {
  dispatch(
    addAudioSplitterSplit({
      id: shortid.generate(),
      position,
    })
  );
  dispatch(hideActiveSplitButton());
  dispatch(hideSplitterSplitButton());
};

const moveSplitterToPosition = position => dispatch => {
  dispatch(
    actions.setAudioSplitterSplitter({
      position,
    })
  );
};

const dropSplitterAtPositionAndHideAcitiveSplitButton = position => dispatch => {
  dispatch(showSplitterSplitButtonAndHideActiveSplitButton());
  dispatch(setLastSplitterPlacementPosition(position));
};

const moveSplitToPosition = (split, positionToMoveTo) => dispatch => {
  // TODO: Might be better to add a reducer for this.
  const newId = shortid.generate();
  dispatch(
    addAudioSplitterSplit({
      id: newId,
      position: positionToMoveTo,
    })
  );
  dispatch(removeAudioSplitterSplit(split));
  dispatch(showActiveSplitButtonForSplitId(newId));
};

const fetchSplit = ({ audio, splitsAtMilliseconds }) => (dispatch, getState) =>
  AnchorApi.fetchSplitAudio({
    webAudioId: audio.id,
    splitsAtMilliseconds,
  }).then(response => response.audios);

export default {
  showSplitterSplitButtonAndHideActiveSplitButton,
  showActiveSplitButtonForIdAndHideSplitterSplitButton,
  setLastSplitterPlacementPosition,
  setIsProcessing,
  showCloseConfirmation,
  hideCloseConfirmation,
  fetchSplit,
  moveSplitToPosition,
  dropSplitterAtPositionAndHideAcitiveSplitButton,
  moveSplitterToPosition,
  openAndSetupForAudio,
  addSplitAtPositionAndHideAllButtons,
  setAudioSplitterSplits,
  setAudioSplitterActiveSplitId,
  closeAndReset,
  play,
  pause,
  pauseAndShowSplitButtonAndHideActiveSplitButton,
  addAudioSplitterSplit,
  removeAudioSplitterSplit,
};
